module.exports = __webpack_public_path__ + "img/thumb-up.bd8e3c40.svg";